// extracted by mini-css-extract-plugin
export default {"contactContainer":"Contact_contactContainer__E3U0a","contact":"Contact_contact__xKAT9","contact_imgBox":"Contact_contact_imgBox__t9LvO"};